import { styled } from '@mui/material/styles';

export const CompanyDetails = styled('span', {
  shouldForwardProp: prop => prop !== 'weight' && prop !== 'size' && prop !== 'bold'
})(({ weight, size, bold, theme }) => ({
  wordBreak: 'break-all',
  fontWeight: bold ? theme.fontWeight.bold : weight,
  ...(size && { fontSize: size })
}));

export const CompanyLabel = styled('span', {
  shouldForwardProp: prop => prop !== 'black' && prop !== 'color'
})(({ theme, black, color }) => ({
  backgroundColor: black ? theme.color.background.dark : color,
  borderRadius: theme.borderRadius.large,
  float: 'left',
  minWidth: '102px',
  textAlign: 'center',
  lineHeight: '1.4',
  color: theme.color.primary.contrast,
  fontSize: theme.fontSize.xsmall,
  marginRight: theme.spacing(0.5),
  padding: theme.spacing(0.25, 1),
  textTransform: 'uppercase'
}));

export const Duration = styled('span')(({ theme }) => ({
  fontSize: theme.fontSize.small,
  fontWeight: theme.fontWeight.bold
}));

export const ExtraDetails = styled('span')(({ theme }) => ({
  fontSize: theme.fontSize.small
}));

export const Text = styled('p')(() => ({
  margin: 0
}));

export const TextSpan = styled('span')(() => ({
  margin: 0
}));

export const TextWrapper = styled('div')(({ theme }) => ({
  flexGrow: 1,
  lineHeight: '1.5em',
  display: 'flex',
  alignItems: 'center'
}));

export const TextWrapperTest = styled('div')(({ theme }) => ({
  flexGrow: 1,
  lineHeight: '1.5em',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const DottedHR = styled('div')(() => ({
  borderTop: '2px dotted #CCCCCC'
}));

export const TitleWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));
